export enum EAccountUpdateType {
  balance = 'balance',
  logout = 'logout',
  restriction = 'restriction',
  subscription = 'subscription',
  table = 'table',
  taskStatus = 'taskStatus',
  achievement = 'achievement',
  notification = 'notification',
}
